import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Box, Typography } from '@mui/material';

// Reusable CustomerChart Component
const CustomerChart = ({ title, data }) => {
  // Render BarChart
  const renderChart = (data) => (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="fullName" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="total" name="Total Price" fill="#8884d8" />
      </BarChart>
    </ResponsiveContainer>
  );

  return (
    <Box>
      <Typography variant="h6">{title}</Typography>
      {renderChart(data)}
    </Box>
  );
};

export default CustomerChart;
